import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconListBullets: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="list-bullets"><path d="M8 6L21 6" stroke="currentColor" strokeWidth="1.5"/><circle cx="4.2" cy="5.9998" r="1.2" fill="currentColor"/><path d="M8 12L21 12" stroke="currentColor" strokeWidth="1.5"/><circle cx="4.2" cy="11.9998" r="1.2" fill="currentColor"/><path d="M8 18L21 18" stroke="currentColor" strokeWidth="1.5"/><circle cx="4.2" cy="17.9998" r="1.2" fill="currentColor"/></CentralIconBase>;
};

export default IconListBullets;
